<div class="dropdown-filter">
  <ng-container *ngFor="let filter of filters">
    <div
      (click)="selectFilter(filter)"
      (keydown.enter)="selectFilter(filter)"
      tabindex="-1"
      class="dropdown-filter__item flex items-center"
    >
      <div class="custom-checkbox" [class.checked]="isChecked(filter.id || filter.nationality)">
        <svg
          *ngIf="isChecked(filter.id || filter.nationality)"
          viewBox="0 0 24 24"
          class="check-icon"
        >
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
        </svg>
      </div>
      <p>{{ filter?.flag }} {{ filter?.nationality }}</p>
    </div>
  </ng-container>
</div>
